export const sanitizeFilename = (filename: string) => {
  // Replace illegal characters with underscores
  return filename.replace(/[/\\:*?"<>|]/g, '_');
};
